import { baseThemeValues } from 'constants/common';

export const previewAppTheme = {
  container: {
    bg: 'palette.secondary.99',
    borderColor: 'palette.surface.5',
    borderRadius: '24px',
    borderWidth: '1px',
  },
  content: {
    appliedFilter: {
      borderColor: 'palette.neutral.40',
      borderRadius: '5px',
      borderWidth: '1px',
      filterName: 'palette.neutral.40',
      filterValue: 'palette.neutral.90',
    },
    bg: 'palette.surface.1',
    button: {
      fontSize: '12px',
      text: 'palette.neutral.40',
    },
    filters: {
      input: {
        fontSize: '10px',
        label: {
          fontSize: '8px',
        },
      },
    },
    select: {
      bg: 'palette.surface.4',
      borderRadius: '5px',
    },
    table: {
      headerCell: {
        bg: 'palette.surface.3',
        borderColor: 'palette.surface.5',
        borderWidth: '1px',
        fontSize: '8px',
        text: 'palette.tertiary.80',
      },
      rowCell: {
        borderColor: 'palette.tertiary.10',
        borderWidth: '1px',
        even: 'palette.surface.5',
        fontSize: '8px',
        odd: 'palette.surface.4',
        text: 'palette.tertiary.90',
      },
      status: {
        fontSize: '8px',
      },
      tag: {
        fontSize: '8px',
      },
    },
    title: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '16px',
      fontWeight: 700,
      text: 'palette.tertiary.90',
    },
  },
  header: {
    bg: 'palette.surface.2',
    logo: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '16px',
      fontWeight: 700,
      text: 'palette.tertiary.90',
    },
  },
  sidebar: {
    bg: 'palette.surface.3',
    controlButton: {
      bg: 'palette.surface.3',
      borderColor: 'palette.tertiary.20',
      borderRadius: '22px',
      borderWidth: '1px',
      text: 'palette.tertiary.50',
    },
    navItem: {
      active: {
        bg: 'palette.surface.5',
        borderColor: 'palette.primary.20',
        borderWidth: '2px',
        fontFamily: baseThemeValues.inherit,
        fontSize: '11px',
        fontWeight: 500,
        text: 'palette.tertiary.90',
      },
      base: {
        bg: 'palette.transparent',
        borderColor: 'palette.transparent',
        borderWidth: '2px',
        fontFamily: baseThemeValues.inherit,
        fontSize: '11px',
        fontWeight: 500,
        text: 'palette.tertiary.50',
      },
    },
  },
};
